module.exports = __webpack_public_path__ + "static/media/wiggle-arrow-small.d49c0e8c.svg";